import React from 'react';
import { FormattedMessage } from 'react-intl';
import lofiPlaylist from "../../assets/icons/signage-plus/lofi-playlist.svg";
import playlistBold from "../../assets/icons/signage-plus/playlist-bold.svg";
import link from '../../assets/icons/signage-plus/link.svg';
import clockIcon from '../../assets/icons/signage-plus/clock-icon.svg';
import weatherIcon from '../../assets/icons/signage-plus/weather-icon.svg';
import calendarIcon from '../../assets/icons/signage-plus/calendar-icon.svg';
import DropdownMenu from './DropdownMenu';
import MediaAccordion from './MediaAccordion';
import CanvaAccordion from './CanvaAccordion';
import SwitchComponent from './SwitchComponent';
import { SIGNAGE_MEDIA } from '../../utils/constants';
import AddButton from './AddButton';
function RenderTabContent({
  activeTab,
  tabData,
  selectedPlaylistId,
  setSelectedPlaylistId,
  selectPlaylist,
  renameId,
  renameValue,
  setRenameId,
  setRenameValue,
  handleRenameBlur,
  handleToggleLoop,
  durationMap,
  handleDelete,
  handleDragStart,
  setLinkItem,
  showAddPlaylist,
  handleDeleteMedia,
  isCanvaAuthenticated,
  canvaUrl,
  isLoading,
  isInitialized,
  handleCanvaSignOut
}) {
  const formatDuration = (duration) => {
    const hours = Math.floor(duration / 3600);
    const minutes = Math.floor((duration % 3600) / 60);
    const seconds = duration % 60;
    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  };

  const renderLoading = () => (
    <div className="flex-col d-flex align-items-center justify-content-center" style={{ height: '200px' }}>
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden"><FormattedMessage id="LOADING" /></span>
      </div>
      <p className="mt-3 text-muted"><FormattedMessage id="LOADING_CONTENT" /></p>
    </div>
  );

  const renderPlaylists = () => {
    // Ensure we only render playlist data
    const validPlaylistData = Array.isArray(tabData) ? tabData.filter(item => 
      item && 
      typeof item === 'object' && 
      item.id && 
      item.name && 
      typeof item.isLoop === 'boolean'
    ) : [];
    
    return (
      <div className="flex-col">
        <ul className="list-group flex-scroll">
          {validPlaylistData.length > 0 && validPlaylistData.map((item, index) => (
          <li
            className={`list-group-item d-flex justify-content-between align-items-center${selectedPlaylistId === item.id ? ' li-selected' : ''}`}
            key={item.id || `playlist-${index}`}
              onClick={(e) => {
                if (e.target.closest('.form-switch')) {
                  return;
                }
                selectPlaylist(item.id);
              }}
          >
            <div className="d-flex align-items-center justify-content-between w-100">
              <div className="d-flex align-items-center" style={{ width: renameId !== item.id ? 'calc(100% - 200px)' : '100%', overflow: "hidden", textOverflow: "ellipsis", whiteSpace: /*"nowrap"*/"pre" }}>
                <img src={playlistBold} alt="" className="icon icon-24" />
                {renameId === item.id ? (
                  <input
                    type="text"
                    className="form-control rounded-0 ms-3"
                    style={{ maxWidth: 300, height: 40, padding: '0 8px' }}
                    value={renameValue}
                    autoFocus
                    onChange={e => setRenameValue(e.target.value)}
                    onBlur={() => handleRenameBlur(item.id)}
                    onKeyDown={e => {
                      if (e.key === 'Enter') {
                        e.preventDefault();
                        handleRenameBlur(item.id);
                      }
                    }}
                  />
                ) : (
                  <span className="ms-3" style={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: /*"nowrap"*/"pre",
                  }} title={item.name}>{item.name}</span>
                )}
              </div>
              <div className="d-flex align-items-center ms-auto">
                {renameId !== item.id && <>
                  <div className="form-check form-switch mx-3">
                    <SwitchComponent check={item.isLoop} labelId="LOOP" id={item.id} onChange={(checked, id) => handleToggleLoop(checked, id)} />
                  </div>
                  <span className="mx-3">
                    {formatDuration(durationMap[item.id] || item.duration)}
                  </span></>
                }
                <DropdownMenu options={[
                  {
                    key: 'rename',
                    label: 'RENAME',
                    onClick: e => {
                      e.preventDefault();
                      setRenameId(item.id);
                      setRenameValue(item.name);
                    }
                  },
                  {
                    key: 'remove',
                    label: 'REMOVE',
                    onClick: e => { e.preventDefault(); handleDelete(item.id) }
                  }
                ]} />
              </div>
            </div>
          </li>
        ))}
      </ul>
      <AddButton labelId="ADD_PLAYLIST" onClick={showAddPlaylist} />
    </div>
    );
  };

  const renderMediaAccordion = () => (
    <MediaAccordion tabData={tabData} onDragStart={handleDragStart} />
  );

  const renderCanva = () => (
    <CanvaAccordion 
      tabData={tabData} 
      onDragStart={handleDragStart} 
      isCanvaAuthenticated={isCanvaAuthenticated}
      canvaUrl={canvaUrl}
      handleCanvaSignOut={handleCanvaSignOut}
    />
  );

  const getIcon = (item) => {
    const iconMap = {
      [SIGNAGE_MEDIA.MEDIA_CATEGORY.LINK]: link,
      [SIGNAGE_MEDIA.MEDIA_CATEGORY.WIDGET]: {
        clock: clockIcon,
        weather: weatherIcon,
        calendar: calendarIcon,
      }[item.subcategory],
      default: lofiPlaylist,
    };
    return <img src={iconMap[activeTab] || playlistBold} alt="" className="icon icon-24" />;
  };

  const renderOtherTabs = () => (
    <div className="flex-col">
      <ul className="list-group mb-3 flex-scroll">
        {Array.isArray(tabData) && tabData.length > 0 && tabData.filter(item => item && typeof item === 'object').map((item, idx) => {
          const canDrag = activeTab !== SIGNAGE_MEDIA.MEDIA_CATEGORY.WIDGET || !!item.id;
          const modalProps = (activeTab === SIGNAGE_MEDIA.MEDIA_CATEGORY.WIDGET && {
            'data-bs-toggle': 'modal',
            'data-bs-target': {
              clock: '#clockModal',
              weather: '#weatherModal',
              calendar: '#calendarModal',
            }[item.subcategory],
          }) || (activeTab === SIGNAGE_MEDIA.MEDIA_CATEGORY.LINK && {
            onClick: e => {
              if (!e.target.closest('.dropdown-center')) {
                e.preventDefault();
                setLinkItem(item);
                const modalElement = document.getElementById('addLinkModal');
                const modalInstance = new window.bootstrap.Modal(modalElement);
                modalInstance.show();
              }
            }
          });
          return (
            <li
              className="list-group-item d-flex justify-content-between align-items-center"
              key={item.id || `${activeTab}-${idx}`}
              draggable={canDrag}
              {...modalProps}
              onDragStart={canDrag ? () => handleDragStart(item, activeTab) : undefined}
            >
              <div className="d-flex align-items-center" style={{ width: 'calc(100% - 30px)' }}>
                {getIcon(item)}
                <span className="ms-3" style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: /*'nowrap'*/'pre' }} title={activeTab === SIGNAGE_MEDIA.MEDIA_CATEGORY.WIDGET ? item.text : item.name}>{activeTab === SIGNAGE_MEDIA.MEDIA_CATEGORY.WIDGET ? item.text : item.name}</span>
              </div>
              {activeTab === SIGNAGE_MEDIA.MEDIA_CATEGORY.LINK && <div className="d-flex align-items-center ms-auto">
                <DropdownMenu options={[
                  {
                    key: 'edit',
                    label: 'EDIT',
                    databstoggle: "modal",
                    databstarget: "#addLinkModal",
                    onClick: e => {
                      e.stopPropagation();
                      e.preventDefault();
                      setLinkItem(item);
                    }
                  },
                  {
                    key: 'remove',
                    label: 'REMOVE',
                    onClick: e => { e.preventDefault(); e.stopPropagation(); handleDeleteMedia(item.id) }
                  }
                ]} />
              </div>}
            </li>
          );
        })}
      </ul>
      {activeTab === SIGNAGE_MEDIA.MEDIA_CATEGORY.LINK && <AddButton modalId="addLinkModal" labelId="ADD_LINKS" />}
    </div>
  );

  // Show loading state when not initialized or for Canva tab when loading
  if (!isInitialized || (activeTab === SIGNAGE_MEDIA.MEDIA_CATEGORY.CANVA && isLoading)) {
    return renderLoading();
  }

  if (activeTab === 'playlists') return renderPlaylists();
  if (activeTab === SIGNAGE_MEDIA.MEDIA_CATEGORY.CANVA) return renderCanva();
  if (activeTab === SIGNAGE_MEDIA.MEDIA_CATEGORY.MEDIA) return renderMediaAccordion();
  return renderOtherTabs();
}

export default RenderTabContent;
